import { useEffect } from 'react';

const FEATURES = [
  {
    number: '01',
    icon: 'ri-user-star-line',
    title: 'Youth Empowerment',
    description: 'We focus on empowering the next generation through engaging programs, mentorship opportunities, and community involvement, ensuring they become future leaders.',
  },
  {
    number: '02',
    icon: 'ri-heart-2-line',
    title: 'Community Outreach',
    description: 'Our church organizes various outreach initiatives aimed at providing support and resources for those in need, fostering a spirit of compassion.',
  },
  {
    number: '03',
    icon: 'ri-hand-heart-line',
    title: 'Inclusive Environment',
    description: 'We celebrate diversity and welcome everyone, creating an inclusive environment where all individuals feel valued and connected to the community.',
  },
  {
    number: '04',
    icon: 'ri-book-open-line',
    title: 'Faith & Scripture',
    description: 'Rooted in God\'s Word, our teachings equip believers with Biblical truth that transforms their daily lives and empowers them to walk boldly in faith.',
  },
  {
    number: '05',
    icon: 'ri-global-line',
    title: 'International Reach',
    description: 'With presence in Cameroon, Ghana, and the USA, TGMCI connects communities across borders through a shared vision of faith and service.',
  },
  {
    number: '06',
    icon: 'ri-seedling-line',
    title: 'Sustainable Impact',
    description: 'Through our outreach and community projects, we create lasting change via education, healthcare, and community development programs that lift entire families.',
  },
];

export default function WhyChooseUs() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <p className="text-accent-600 font-label text-sm tracking-widest uppercase font-semibold mb-3">
            Why Choose Us
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            Discover the Unique Ways We Make a Difference
          </h2>
          <div className="w-12 h-1 bg-accent-500 mt-5 mx-auto" />
          <p className="text-foreground-500 mt-5 text-base leading-relaxed">
            At TGMCI, we are more than a church — we are a family committed to uplifting lives and building community through faith, love, and service.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {FEATURES.map((f, idx) => (
            <div
              key={f.title}
              className={`reveal bg-background-50 rounded-xl p-7 border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all group`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-600 group-hover:text-white transition-colors shrink-0">
                  <i className={`${f.icon} text-xl`} aria-hidden="true" />
                </div>
                <div className="text-4xl font-heading font-bold text-background-200 group-hover:text-background-300 transition-colors select-none">
                  {f.number}
                </div>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-800 mb-3">
                {f.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}